import {
  Dialog,
  DialogContent,
  IconButton,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

const CustomDialogModal = ({
  open,
  onClose,
  children,
  sxContent = {},
  sxDialog = {},
  showCloseIcon = true,
  ...props
}) => {
  const { showCerrar, narrow, ...rest } = props;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // valores por defecto de ancho del modal
  const defaultPaperSx = {
    margin: 'auto',
    maxWidth: { xs: '320px', sm: '420px', md: '480px', lg: '650px' },
    width: '100%',
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      sx={{
        '&.MuiModal-root': { maxWidth: 'none !important' },
        '& .MuiDialog-paper': {
          ...defaultPaperSx,
          ...sxDialog['& .MuiDialog-paper'], // permite override dinámico
        },
        ...sxDialog, // cualquier otro override que venga
      }}
      PaperProps={{ sx: { p: { xs: 2, sm: 3 } } }}
      {...rest}
    >
      {isMobile && (
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            color: 'red',
            display: showCloseIcon ? 'block' : 'none',
          }}
        >
          <CancelIcon />
        </IconButton>
      )}

      <DialogContent sx={{ p: 0, ...sxContent }}>{children}</DialogContent>
    </Dialog>
  );
};

export default CustomDialogModal;
